import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const RatingRedux = createActions(
  {
    submitRatingRequest: ['ratingInfo'],
    submitRatingSuccess: ['response'],
    submitRatingError: ['err'],
    setAlreadyRated: ['rate'],
    resetError: [],
  },
  {
    prefix: 'PARENT_PLATFORM_RATING_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = RatingRedux
export const RatingTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  rating: {
    fetching: false,
    result: {},
    error: null,
  },
  hasRated: false,
}, {
  get: true,
})


const submitRatingRequest = state => state.merge({
  rating: {
    fetching: true,
    result: {},
    error: null,
  },
}, d)
const submitRatingSuccess = (state, { response }) => state.merge({
  rating: {
    fetching: false,
    result: response,
    error: null,
  },
  hasRated:true,
}, d)
const submitRatingError = (state, { err }) => state.merge({
  rating: {
    fetching: false,
    result: null,
    error: err,
  },
  hasRated:false,
}, d)

const setAlreadyRated = (state, { rate }) => state.merge({
  hasRated: rate,
})
const resetError = state => state.merge({ rating: { fetching: false, error: null } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.submitRatingRequest]: submitRatingRequest,
    [Types.submitRatingSuccess]: submitRatingSuccess,
    [Types.submitRatingError]: submitRatingError,
    [Types.setAlreadyRated]: setAlreadyRated,
    [Types.resetError]: resetError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/RatingRedux.js